import ApiDetail from './ApiDetail/index'

export default ApiDetail
